import type { BatchPreviewTableProps } from "./batch-preview-table.type";
import type { BatchPreviewItem } from "../batch-preview.type";

import { Empty, Table } from "antd";
import { useTranslation } from "react-i18next";

import { BATCH_PREVIEW_PAGE_SIZE } from "../batch-preview.constant";

export const BatchPreviewTable = <Item extends BatchPreviewItem>({
  model,
  items,
  loading,
  columns,
}: BatchPreviewTableProps<Item>) => {
  const { t } = useTranslation();

  return (
    <Table
      size="small"
      rowKey="id"
      dataSource={items}
      loading={loading}
      columns={columns}
      locale={{
        emptyText: <Empty description={t(`global:empty.${model}`)} />,
      }}
      pagination={{
        defaultPageSize: BATCH_PREVIEW_PAGE_SIZE,
        hideOnSinglePage: true,
      }}
    />
  );
};
